import { useHistory, useParams } from 'react-router-dom';
import { Box, Fade, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useDocument_GetDocumentsCountForEstatesQuery } from 'queries';

import HomeLayout from 'layouts/home-layout';
import { EstateDashboardTab } from 'pages/estate-dashboard/estate-dashboard';
import { NotificationSeverity, showAlert } from 'utils/notification-manager';

const useStyles = makeStyles(() => ({
  parentContainer: {
    color: '#1C2541',
  },
  pageTitle: {
    marginBottom: '24px',
  },
  estateIconContainer: {
    width: 48,
    height: 48,
    color: '#fff',
    fontSize: 32,
    fontWeight: 700,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 8,
    marginRight: 16,
  },
  title: {
    fontSize: '32px',
    fontWeight: 700,
    marginBottom: '24px',
  },
  subtitle: {
    marginBottom: '24px',
    fontWeight: 300,
  },
  gridItem: {
    border: '1px solid #ECEEF1',
    borderRadius: '16px',
    padding: '0 16px',
    height: '80px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.05)',
  },
  estateDocumentCount: {
    fontSize: '12px',
    color: '#9DA8B4',
  },
  estateTitle: {
    fontSize: '20px',
    marginBottom: '24px',
  },
}));

const colors = ['#5ED1F0', '#F79009', '#DB5461', '#772AD8', '#1A7B53', '#2E90FA'];

const VaultPage = () => {
  const history = useHistory();
  const classes = useStyles();
  const { portalId } = useParams<Record<string, string>>();
  const { data: estatesData } = useDocument_GetDocumentsCountForEstatesQuery({
    variables: { portalId },
    onError: (e) => {
      showAlert({
        message: 'Error finding estates by portal ID: ' + e.message,
        severity: NotificationSeverity.ERROR,
      });
    },
  });

  const estates = estatesData?.data ?? [];

  return (
    <HomeLayout>
      <Fade in={true}>
        <div className={classes.parentContainer}>
          <Typography className={classes.pageTitle}>Vault Page</Typography>
          <Typography variant="subtitle1" className={classes.subtitle}>
            Files uploaded by you across all estates and other files shared with you.
          </Typography>
          <Typography variant="h6" className={classes.estateTitle}>
            Estates
          </Typography>
          <Grid container rowSpacing={3} columnSpacing={3}>
            {estates.map((estate) => {
              return (
                <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={estate.estateId}>
                  <Box
                    className={classes.gridItem}
                    onClick={() => {
                      history.push(
                        `/home/${portalId}/estate/${estate.estateId}/estate-dashboard?tab=${EstateDashboardTab.VAULT}`,
                      );
                    }}
                  >
                    <Box
                      className={classes.estateIconContainer}
                      sx={{
                        backgroundColor: colors[Math.floor(Math.random() * colors.length)],
                      }}
                    >
                      <div>{estate.estateName.charAt(0).toUpperCase()}</div>
                    </Box>
                    <div>
                      <div>{estate.estateName}</div>
                      <Typography className={classes.estateDocumentCount}>
                        {estate.estateDocumentsCount}{' '}
                        {estate.estateDocumentsCount > 1 ? 'files' : 'file'}
                      </Typography>
                    </div>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </div>
      </Fade>
    </HomeLayout>
  );
};

export default VaultPage;
